import React, { Fragment, useState, useEffect, useContext } from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, Image, H6, P } from "../../AbstractElements";
import { useController, useForm } from "react-hook-form";
import { megaLogo } from "../../api";
import {
  EmailAddress,
  ForgotPassword,
  Continue,
  Password,
  RememberPassword,
} from "../../Constant";
import { postForgotPassword, verifyOtp } from "../../Services/Auth.service";
import { useNavigate } from "react-router";

const ForgotTab = () => {
  const [email, setEmail] = useState();
  const [loading, setLoading] = useState(false);
  const [formSubmitFlag, setFormSubmitFlag] = useState(false);
  const [isEmail, setIsEmail] = useState(true)
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    control,
    getValues,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
      mobile: "",
    }
  });

  const [forgotPasswordRes, setForgotPasswordRes] = useState(() => {
    return {
      message: null,
      color: null,
    };
  });

  const driverMobileField = useController({
    name: "mobile",
    control,
    rules: {
      required: {
        value: true,
        message: "Phone Number is Required",
      },
      minLength: {
        value: 10,
        message: "Phone Number cannot be less than 10",
      },
      maxLength: {
        value: 10,
        message: "Phone Number cannot be more than 10",
      },
      min: {
        value: 0,
        message: "Invalid Phone Number",
      },
      maxLength: 10
    },
  }).field;

  const submitForgotForm = () => {
    const formValues = getValues()
    if (isEmail && (!formValues.email || !(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formValues.email)))) {
      setForgotPasswordRes({
        message: "Please enter a valid Email ID",
        color: "red",
      });
      return
    }
    if (!isEmail && (!formValues.mobile || formValues.length < 10)) {
      setForgotPasswordRes({
        message: "Please enter a valid Phone Number",
        color: "red",
      });
      return
    }
    let body = {
      email: formValues.email ? formValues.email : null,
      mobile: formValues.mobile ? Number(formValues.mobile) : null,
    }
    setLoading(true);
    postForgotPassword(body)
      .then((result) => {
        setLoading(false);
        console.log(result);
        if (isEmail) {
          setFormSubmitFlag(true);
        } else {
          navigate(`/verifyotp`, {
            state: {
              mobile: formValues.mobile
            }
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        setForgotPasswordRes({
          message: err.response?.data?.message
            ? err.response.data.message
            : "Something went wrong",
          color: "red",
        });
      });
  };

  const redirectTologin = () => {
    window.location.href = `${process.env.PUBLIC_URL}/login`;
  };

  console.log("values", getValues())

  return (
    <Fragment>
      <div className="theme-form">
        <Row className="customer-logo">
          <Image
            attrImage={{
              className: "img-fluid d-inline",
              src: megaLogo,
              alt: "",
            }}
          />
        </Row>
        {!formSubmitFlag ? <Col style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <H6>Forgot password?</H6>
          <FormGroup className="col-lg-12" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div className="m-checkbox-inline mb-0 custom-radio-ml" style={{ display: "flex", alignItems: "center" }}>
              <div className="radio radio-primary">
                <Input id="radioinline2" type="radio" name="isPrimary" checked={isEmail} onChange={() => {
                  setIsEmail(true)
                  reset()
                  setForgotPasswordRes({
                    message: null,
                    color: null,
                  })
                }} />
                <Label className="mb-0" for="radioinline2">{"Email ID"}</Label>
              </div>
              <div className="radio radio-primary">
                <Input id="radioinline3" type="radio" name="isSecondary" checked={!isEmail} onChange={() => {
                  setIsEmail(false)
                  reset()
                  setForgotPasswordRes({
                    message: null,
                    color: null,
                  })
                }} />
                <Label className="mb-0" for="radioinline3">{"Phone Number"}</Label>
              </div>
            </div>
          </FormGroup>
        </Col> : null}
        {isEmail ? (
          <>
            {!formSubmitFlag ? (
              <Fragment>
                <Row className="forgot-pwd-content">
                  <P>
                    Enter your Email ID and we'll send you a link to get back into your
                    account
                  </P>
                </Row>
                <FormGroup>
                  <Label className="col-form-label">{EmailAddress}</Label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter Email ID"
                    {...register("email", {
                      required: {
                        value: true,
                        message: "Email is required",
                      },
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        message: "Please enter a valid email !",
                      },
                      onChange: (e) => {
                        setValue("email", e.target.value.trim())
                      }
                    })}
                  />
                </FormGroup>
                <span style={{ color: "red" }}>{errors?.email?.message}</span>
                <div>
                  {forgotPasswordRes.message ? (
                    <span style={{ color: forgotPasswordRes.color }}>
                      {forgotPasswordRes.message}
                    </span>
                  ) : (
                    ""
                  )}
                </div>

                <div className="position-relative form-group mb-0">
                  <Btn
                    attrBtn={{
                      color: "primary",
                      className: "d-block w-100 mt-2",
                      disabled: loading ? loading : loading,
                      onClick: (e) => submitForgotForm(),
                    }}
                  >
                    {loading ? "LOADING..." : Continue}
                  </Btn>
                </div>
              </Fragment>
            ) : (
              <Fragment>
                <Row className="forgot-pwd-content">
                  <H6>Reset password?</H6>
                  <P>
                    We sent instructions to your Email id with a link to get back in
                    to your account
                  </P>
                </Row>
                <div className="position-relative form-group mb-0">
                  <Btn
                    attrBtn={{
                      color: "primary",
                      className: "d-block w-100 mt-2",
                      disabled: loading ? loading : loading,
                      onClick: (e) => redirectTologin(),
                    }}
                  >
                    {loading ? "LOADING..." : "Back To Login"}
                  </Btn>
                </div>
              </Fragment>
            )}
          </>) : (<>
            <Fragment>
              <Row className="forgot-pwd-content">
                <P>
                  Enter your Phone Number and we'll send you OTP to verify your
                  account
                </P>
              </Row>
              <FormGroup>
                <Label className="col-form-label">Phone Number</Label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Phone Number"
                  maxLength={10}
                  value={driverMobileField.value}
                  pattern="[0-9]+"
                  onChange={(e) => {
                    driverMobileField.onChange(e.target.value.replace(/[^0-9]/g, ''))
                  }}
                />
              </FormGroup>
              <span style={{ color: "red" }}>{errors?.mobile?.message}</span>
              <div>
                {forgotPasswordRes.message ? (
                  <span style={{ color: forgotPasswordRes.color }}>
                    {forgotPasswordRes.message}
                  </span>
                ) : (
                  ""
                )}
              </div>

              <div className="position-relative form-group mb-0">
                <Btn
                  attrBtn={{
                    color: "primary",
                    className: "d-block w-100 mt-2",
                    disabled: loading ? loading : loading,
                    onClick: (e) => submitForgotForm(),
                  }}
                >
                  {loading ? "LOADING..." : Continue}
                </Btn>
              </div>
            </Fragment>

          </>)}
        {/* <SocialAuth /> */}
      </div>
    </Fragment>
  );
};

export default ForgotTab;
